import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {formatTimestamp} from "../../utils";
import {CircularProgress} from "@mui/material";
import {CheckCircle} from "@mui/icons-material";

export const BiddingDialog = ({open, handleClose, biddingRow, previousBids, userBankTotals, bidAmount, maxBidAmount, onBidAmountChange, onMaxBidAmountChange, bidError, helperText, maxBidHelperText, onSubmitMaxBidUpdate, onSubmitBid, onSubmitImOutBid, updatable, updating, updated}) => {
    return (
        <Dialog open={open} onClose={handleClose} closeAfterTransition={false}>
            <DialogTitle id="place-bid-dialog">
                {`${biddingRow.first_name} ${biddingRow.last_name} - ${biddingRow.pos} - ${biddingRow.team}`}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Previous bids:
                </DialogContentText>
                <TableContainer>
                    <Table>
                        <TableBody>
                            {previousBids.map((bid) => (
                                <TableRow key={`bid${bid.id}`}>
                                    <TableCell>{bid.manager_name}</TableCell>
                                    <TableCell>{bid.amount === 0 ? biddingRow.season_year < 2023 ? '(Amount unknown)' : 'OUT' : bid.amount}</TableCell>
                                    <TableCell>{formatTimestamp(bid.time)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {biddingRow.bid_group_is_open &&
                <div>
                <DialogContentText style={{paddingTop: 40}}>
                    Your auto-bid max (optional):
                </DialogContentText>
                <TextField id="maxBidAmountField" label="Amount" variant="outlined" type="number"
                           value={maxBidAmount ? maxBidAmount : ''}
                           onChange={onMaxBidAmountChange} helperText={maxBidHelperText}/>
                <Button variant="contained" type="submit" color="primary" style={{marginLeft: 10, verticalAlign: "top"}}
                        onClick={onSubmitMaxBidUpdate} disabled={!updatable}>Update</Button>
                {updating && <CircularProgress size="2rem" style={{marginLeft: 10}}/>}
                {updated && <CheckCircle color="secondary" style={{marginLeft: 10, marginTop: 5}}/>}
                <DialogContentText style={{paddingTop: 40}}>
                    Your current bank:
                </DialogContentText>
                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>Used:</TableCell>
                                <TableCell>{userBankTotals.spent}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Available:</TableCell>
                                <TableCell>{userBankTotals.available}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <DialogContentText style={{paddingTop: 40}}>
                    Place bid:
                </DialogContentText>
                <TextField id="bidAmountField" label="Amount" variant="outlined" type="number" value={bidAmount}
                           onChange={onBidAmountChange} error={bidError} helperText={helperText}/>
                <Button variant="contained" type="submit" color="primary" style={{marginLeft: 10}} onClick={onSubmitBid} disabled={bidError || updatable}>Submit</Button>
                <Button variant="contained" type="submit" color="primary" style={{marginLeft: 10}} onClick={onSubmitImOutBid}>I'm out</Button>
                </div>}
            </DialogContent>
        </Dialog>
    );
}